import {AbstractProfileCollection} from './abstractProfileCollection';
import {Language} from '../model/language';

export const Languages = AbstractProfileCollection.extend({
    _name : 'Languages',
    model : Language,
    urlRoot : '/languages/get.json'
});
